import script from "./excipient-warning-hint.vue?vue&type=script&setup=true&lang=js"
export * from "./excipient-warning-hint.vue?vue&type=script&setup=true&lang=js"

import "./excipient-warning-hint.vue?vue&type=style&index=0&id=8733f49a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8733f49a"]])

export default __exports__